import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import FauxRookPiercingImage from '../../Assets/Piercing Services/faux rook piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function FauxRookPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Faux Rook Piercing UAE | 150-175 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Faux Rook Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Faux Rook Piercing 150-175 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={FauxRookPiercingImage} alt="Faux Rook Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Faux Rook Piercing</h3>

          <p>
            Achieve a stylish and modern ear look with our professional faux rook piercing services in the UAE, available at an affordable price range of 150–175 AED. Faux rook piercing is a unique and trendy alternative to the traditional rook piercing, designed to mimic the same aesthetic without deep cartilage involvement. This surface-level piercing creates the illusion of a rook piercing while offering a more comfortable and less invasive experience, making it an excellent choice for individuals who love the look of inner ear piercings but prefer a gentler option. Whether you are exploring new styles or adding to your existing ear design, our expert specialists ensure precise placement for a clean, balanced, and visually appealing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and client comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each faux rook piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth procedure. Our goal is to provide a quick, efficient, and pain-minimized experience, making faux rook piercing suitable for both beginners and experienced piercing enthusiasts.
          </p>

          <p>
            Faux rook piercing is ideal for individuals who want a bold and fashionable ear style without the intensity of a traditional cartilage piercing. Its placement gives the appearance of a rook piercing while sitting more comfortably on the surface, making it easier to heal and maintain. This makes it a popular choice for those who want to experiment with unique ear styling while keeping comfort in mind. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your ear anatomy and personal style.
          </p>

          <p>
            The procedure is typically completed within minutes, ensuring minimal discomfort and maximum convenience. Our team uses advanced techniques designed to reduce pain and promote faster healing, allowing you to enjoy your new piercing without unnecessary stress. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that trying a new piercing style can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and comfortable experience tailored to your needs.
          </p>

          <p>
            Aftercare is an essential part of maintaining your faux rook piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your faux rook piercing will heal effectively and remain a stylish and long-lasting addition to your look.
          </p>

          <p>
            Our faux rook piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted faux rook piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a trendy and comfortable alternative to traditional cartilage piercings. Book your faux rook piercing appointment today and elevate your ear styling with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Faux Rook Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FauxRookPiercing;